var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var CalculateSettingsModalController = /** @class */ (function (_super) {
            __extends(CalculateSettingsModalController, _super);
            function CalculateSettingsModalController($scope, workflowBlock, processConfigId, isReadonly, calculationService, treeService, schemaPropertyService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.workflowBlock = workflowBlock;
                _this.scope.isReadonly = isReadonly;
                _this.scope.processConfigId = processConfigId;
                _this.scope.model = new CalculateSettingsModel(treeService, schemaPropertyService, workflowBlock.calculateDto);
                _this.scope.calculationChanged = function () { return _this.scope.workflowBlock.componentId = _this.scope.workflowBlock.calculateDto.calculationId; };
                calculationService.getAllCalculations(processConfigId).then(function (calculations) { return _this.scope.calculations = calculations; });
                return _this;
            }
            return CalculateSettingsModalController;
        }(controllers.BaseModalController));
        controllers.CalculateSettingsModalController = CalculateSettingsModalController;
        var CalculateSettingsModel = /** @class */ (function () {
            function CalculateSettingsModel(treeService, schemaPropertyService, calculateDto) {
                var _this = this;
                this.treeService = treeService;
                this.schemaPropertyService = schemaPropertyService;
                this.calculateDto = calculateDto;
                if (calculateDto.resultSchemaPropertyId) {
                    this.schemaPropertyService.getSchemaProperty(calculateDto.resultSchemaPropertyId).then(function (schemaProperty) { return _this.schemaProperty = schemaProperty; });
                }
            }
            CalculateSettingsModel.prototype.onDragOver = function ($event) {
                //var treeConfig = this.treeService.getTreeConfigurationItem();
            };
            CalculateSettingsModel.prototype.onDrop = function ($event) {
                var _this = this;
                var treeConfig = this.treeService.getTreeConfigurationItem();
                this.calculateDto.resultSchemaPropertyId = treeConfig.schemaPropertyId;
                this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(function (schemaProperty) { return _this.schemaProperty = schemaProperty; });
                $event.preventDefault();
                $event.stopPropagation();
                this.treeService.clearDragValue();
            };
            return CalculateSettingsModel;
        }());
        controllers.CalculateSettingsModel = CalculateSettingsModel;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('CalculateSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'calculationService', 'treeService', 'schemaPropertyService', 'close']);
